import React, { ReactElement, useEffect } from 'react';
import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';
import { Loader } from '../../../../shared/ui/ui-kit/elements/Loader';

interface ContentProps {}

function Content({}: ContentProps): ReactElement {
  const { authorizationUiModule } = useUILogic();

  useEffect(() => {
    authorizationUiModule.tryLogin();
  }, []);

  return <Loader />;
}

export { Content };
